import React from 'react';
import {
    Chart,
    Series,
    ArgumentAxis,
    CommonSeriesSettings,
    CommonAxisSettings,
    Grid,
    Legend,
    Margin,
    Tooltip,
    Label,
    ValueAxis,
    Format
} from 'devextreme-react/chart';

import { Size } from "devextreme-react/vector-map";


class SplineChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            type: 'spline'
        };
        this.types = ['spline', 'stackedspline', 'fullstackedspline'];
        this.handleChange = this.handleChange.bind(this);
    }

    customizeTooltip = ({ seriesName, valueText }) => {
        if (this.props.kpi === "QMAgentCompared") {
            return {
                text: `${valueText}/${this.props.defaultVisualRange[1]}`,
            };
        } else {
            return {
                text: `${valueText}`,
            };
        }
    }

    render() {
        return (
            <React.Fragment>
                <Chart
                    palette={this.props.palette}
                    ref={this.props.reference}
                    dataSource={this.props.data}
                >
                    <CommonSeriesSettings
                        argumentField="time"
                        type={this.state.type}
                    />
                    <CommonAxisSettings>
                        <Grid visible={true} />
                    </CommonAxisSettings>
                    {
                        this.props.source.map(function (item) {
                            return <Series key={item.value} valueField={item.value} name={item.name} />;
                        })
                    }
                    <Margin bottom={20} />
                    <ArgumentAxis
                        allowDecimals={false}
                        axisDivisionFactor={60}
                        defaultVisualRange={this.props.defaultVisualRange}
                    >
                        <Label>
                            <Format type="decimal" />
                        </Label>
                    </ArgumentAxis>
                    <ValueAxis
                        defaultVisualRange={this.props.defaultVisualRange}
                    />
                    <Legend
                        margin={0}
                        horizontalAlignment="center"
                        verticalAlignment="bot"
                    />
                    <Tooltip enabled={true} container="#chart-modal" customizeTooltip={this.customizeTooltip} />

                    <Size
                        height={this.props.size.height}
                        width={this.props.size.width}
                    />
                </Chart>

            </React.Fragment>
        );
    }

    handleChange(e) {
        this.setState({ type: e.value });
    }
}

export default SplineChart;
